module.exports = __webpack_public_path__ + "img/9788992055246.e2e46fdc.jpg";